import { ReactNode, useEffect } from 'react'
import styled from 'styled-components'
import {
  CompanyInformation_CompanyInformationFragment,
  CompanyInformationNotCachedQuery_CompanyInformationFragment,
  useGqlCompanyInformationNotCachedQueryQuery,
  useGqlViewCompanyMutation,
} from 'generated/graphql'
import CompanyInfoRelated from '../contents/CompanyInfoRelated'
import CompanyInfoDetailHeader from '../header/CompanyInfoDetailHeader'
import CompanyInfoDetailTabs from '../tabs/CompanyInfoDetailTabs'

interface CompanyInfoDetailLayoutMobileProps {
  companyInformation: CompanyInformation_CompanyInformationFragment
  children: ReactNode
}

const CompanyInfoDetailLayoutMobile = ({
  companyInformation,
  children,
}: CompanyInfoDetailLayoutMobileProps) => {
  const [viewCompany] = useGqlViewCompanyMutation()

  useEffect(() => {
    if (companyInformation?.companyId) {
      viewCompany({
        variables: { companyId: companyInformation?.companyId || '' },
      })
    }
  }, [viewCompany, companyInformation?.companyId])

  const { data: csrData } = useGqlCompanyInformationNotCachedQueryQuery({
    variables: { companyInformationId: companyInformation?.id || '' },
    fetchPolicy: 'cache-and-network',
    skip: !companyInformation,
  })

  const mergedData: Partial<
    CompanyInformation_CompanyInformationFragment &
      CompanyInformationNotCachedQuery_CompanyInformationFragment
  > = {
    ...companyInformation,
    viewerInterestedIn: csrData?.companyInformation?.viewerInterestedIn,
    company: {
      ...companyInformation.company,
      interestCount: csrData?.companyInformation?.company?.interestCount || 0,
      viewCount: csrData?.companyInformation?.company?.viewCount || 0,
      shareCount: csrData?.companyInformation?.company?.shareCount || 0,
    },
  }

  return (
    <StyledWrapper>
      <CompanyInfoDetailHeader data={mergedData} />
      <CompanyInfoDetailTabs />
      {children}
      <CompanyInfoRelated companyId={companyInformation.companyId} />
    </StyledWrapper>
  )
}

export default CompanyInfoDetailLayoutMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
